@if (isLoading()) {
  @if (small()) {
    <div
      class="bg-surface-0/80 absolute inset-0 z-10 flex items-center justify-center rounded-lg"
      aria-live="polite"
      aria-label="Chargement en cours"
      aria-busy="true"
    >
      <p-progressSpinner class="size-20" />
    </div>
  } @else {
    <p-blockui
      [blocked]="isLoading()"
      class="bg-surface-0/80! fixed inset-0 flex items-center justify-center"
      aria-live="polite"
      aria-label="Chargement en cours"
    >
      <p-progressSpinner />
    </p-blockui>
  }
}
